import rest from "../script/rest";

class WorstcaseDataRest {

    async isAvailable(entryId, worstcaseDataFarField) {
        const url = "/rest/worstcaseData/isAvailable"
            + "?entryId=" + entryId
           + "&worstcaseDataFarField=" + worstcaseDataFarField;
        const response = await rest.get(url);
        return response.json();
    }
}
const worstcaseDataRest = new WorstcaseDataRest();
window.worstcaseDataRest = worstcaseDataRest;
export default worstcaseDataRest;